import React, { FC } from 'react';

import { ModifierTypes } from 'state/product-wizard-v2/types';

import { ModifierCheckbox } from './modifier-checkbox';
import { ModifierMultipleChoices } from './modifier-multiple-choices';
import { ModifierNonNumeric } from './modifier-non-numeric';
import { ModifierSingleChoice } from './modifier-single-choice';
import { IModifierProps } from './types';
import { getModifierType } from './utils';

const Modifier: FC<IModifierProps> = props => {
  const { modifier } = props;

  const modifierType = getModifierType(modifier);

  const renderModifierUI = () => {
    switch (modifierType) {
      case ModifierTypes.NON_NUMERIC:
        return <ModifierNonNumeric {...props} />;
      case ModifierTypes.CHECKBOX:
        return <ModifierCheckbox {...props} />;
      case ModifierTypes.NUMERIC:
        return null;
      case ModifierTypes.SINGLE_CHOICE:
        return <ModifierSingleChoice {...props} />;
      case ModifierTypes.MULTIPLE_CHOICE:
        return <ModifierMultipleChoices {...props} />;
      default:
        return null;
    }
  };

  return renderModifierUI();
};

export default Modifier;
